import { object, string } from 'yup';

import { Advertiser } from 'modules/organization/organizationApiTypes';

export interface AdvertiserFormInputs {
  name: string;
  dspId?: string;
  linkedAdvertiserId?: string;
  currency?: string;
  agencyId?: string;
}
export const MAX_LENGTH = 30;

export const getSchema = (requireDspId: boolean) =>
  object().shape({
    name: string().trim().required('Name is required'),
    dspId: requireDspId
      ? string().trim().required('Linked advertiser is required')
      : string().trim(),
    linkedAdvertiserId: string().trim(),
    currency: string().trim(),
  });

// Schema for edit modal that doesn't require dspId
export const editSchema = object().shape({
  name: string().trim().required('Name is required'),
  linkedAdvertiserId: string().trim(),
  currency: string().trim(),
  agencyId: string().trim(),
});

export type CreateAdvertiserModalProps = {
  onClose: () => void;
};
export type EditAdvertisersModalProps = {
  onClose: () => void;
  selectedAdvertiser: Advertiser | null;
};
